/* eslint-disable react/jsx-no-target-blank */
import React, {Fragment} from 'react'
import {useIntl} from 'react-intl'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import routes from '../../App/PrivateRoutes'
import {useSelector} from 'react-redux'
import {ListLoading} from '../../components/Table/ListLoading'
import {selectDigitalPlanetSettings} from '../../redux/slices/digitalplanetsettings.slice'
import {selectEdmSettings} from '../../redux/slices/edmsettings.slice'

export function AsideMenuMain() {
  const intl = useIntl()
  const {info, loading} = useSelector((state) => state.profile)
  const userRolesSet = new Set(info?.roles)
  const digitalPlanetSettings = useSelector(selectDigitalPlanetSettings)
  const edmSettings = useSelector(selectEdmSettings)

  const isFeatureEnabled = (featureKey) => {
    if (featureKey === 'digitalPlanet') return digitalPlanetSettings?.isEnabled === true
    if (featureKey === 'edm') return edmSettings?.isEnabled === true
    return true
  }

  if (info)
    return (
      <>
        {loading && <ListLoading />}

        {!loading && (
          <>
            {routes?.map((route) => {
              const routeRoles = route.role

              if (route?.visibility == 'hidden') return <Fragment key={route.key} />

              if (route?.child) {
                const hasUserRole = routeRoles.some((role) => userRolesSet.has(role))

                if (hasUserRole) {
                  return (
                    <AsideMenuItemWithSub
                      to={route.path}
                      title={intl.formatMessage({id: route.title})}
                      fontIcon='bi-archive'
                      icon={route?.icon}
                      key={route.key}
                    >
                      {route.child.map((children) => {
                        const hasChildRole = children?.role?.some((role) => userRolesSet.has(role))
                        if (children?.featureKey && !isFeatureEnabled(children.featureKey))
                          return <Fragment key={children.key} />

                        if (children?.claimType) {
                          const claimType = info?.claims?.find(
                            (item) =>
                              item.type == children?.claimType && item.value == children?.claimValue
                          )

                          if (!claimType) return <Fragment key={children.key} />
                        }

                        if (children?.role && children?.role?.length > 0 && !hasChildRole)
                          return <Fragment key={children.key} />

                        if (children?.child) {
                          return (
                            <AsideMenuItemWithSub
                              key={children.key}
                              to={children.path}
                              title={intl.formatMessage({id: children.title})}
                              hasBullet={true}
                              className='ps-9'
                            >
                              {children.child.map((grandChild) => {
                                const hasGrandChildRole = grandChild?.role?.some((role) =>
                                  userRolesSet.has(role)
                                )

                                if (grandChild?.claimType) {
                                  const claimType = info?.claims?.find(
                                    (item) =>
                                      item.type == grandChild?.claimType &&
                                      item.value == grandChild?.claimValue
                                  )
                                  if (!claimType) return <Fragment key={grandChild.key} />
                                }

                                if (
                                  grandChild?.role &&
                                  grandChild?.role?.length > 0 &&
                                  !hasGrandChildRole
                                ) {
                                  return <Fragment key={grandChild.key} />
                                }

                                return (
                                  <AsideMenuItem
                                    key={grandChild.key}
                                    to={grandChild.path}
                                    title={intl.formatMessage({id: grandChild.title})}
                                    hasBullet={true}
                                    className='ps-9'
                                  />
                                )
                              })}
                            </AsideMenuItemWithSub>
                          )
                        }

                        return (
                          <AsideMenuItem
                            key={children.key}
                            to={children.path}
                            title={intl.formatMessage({id: children.title})}
                            hasBullet={true}
                            className='ps-13'
                          />
                        )
                      })}
                    </AsideMenuItemWithSub>
                  )
                }
              }

              const hasRole = routeRoles.some((role) => userRolesSet.has(role))

              if (hasRole || route.role.includes('All')) {
                return (
                  <AsideMenuItem
                    to={route.path}
                    icon={route.icon}
                    title={intl.formatMessage({id: route.title})}
                    fontIcon='bi-archive'
                    key={route.key}
                  />
                )
              }

              return <Fragment key={route.key} />
            })}
          </>
        )}
      </>
    )

  return <></>
}
